export default {
  components: {
    locationSelector: {
      labelKey: 'cmp-bus-directory-map-sub-title-key-location',
      inputItem: {
        placeholder: 'cmp-preposition--origin-place',
      },
    },
    destinationSelector: {
      inputItem: {
        placeholder: 'cmp-preposition--destination-place',
      },
    },
    list: {
      itemSettings: {
        open: true,
        showCallToAction: false,
        showHoursOperation: false,
        showTicketTypes: false,
        showSpecialInstructions: false,
        showTelephoneNumbers: false,
        showLocationType: false,
      },
    },
    bookNowSettings: {
      marginTop: '2',
    },
  },
  uiDisplay: {
    showDestination: true,
    showBookNow: true,
  },
  prePopulation: {
    locationSearchOptions: {
      outputCategory: ['CITIES'],
    },
  },
};
